export function getCountryName(countryCode: string, languageCode: string, fallback: string): string {
  try {
    return new Intl.DisplayNames(languageCode, { type: "region" }).of(countryCode) ?? fallback;
  } catch (error) {
    console.warn(`Could not get country name for code ${countryCode} and language ${languageCode}:`, error);
    return fallback;
  }
}
